import { useRouteMatch } from 'react-router-dom';

export const useEmployeeEnrollmentParams = () => {
  const {
    params: { id: employeeId, enrollmentId: accountId },
  } = useRouteMatch<{
    id: string;
    enrollmentId: string;
  }>();
  return { employeeId, accountId };
};
